import { create } from "zustand";

type LogoutTrackerState = {
  logoutHasStarted: boolean;
  startLogout: () => void;
};

export const useLogoutTracker = create<LogoutTrackerState>(set => ({
  logoutHasStarted: false,
  startLogout: () => set(() => ({ logoutHasStarted: true })),
}));
